import styled from 'styled-components';
import { Format, StyleColor, BaseStyledComponentProps } from '../../../../utils/styles-constants';
import { hexToRgba } from '../../../../utils/style';

const SearchFieldContainer = styled('div')`
	display: flex;
	flex-flow: row nowrap;
	background-color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.backgroundColor, 100)};
	position: absolute;
	z-index: 5;
	box-sizing: border-box;
	width: 100%;
	top: 0;
	left: 0;
	padding: 15px 50px;
	z-index: 2;
	transition: all 0.3s;
	background-color: ${(props: BaseStyledComponentProps) => props.theme.primary.backgroundColor };
	box-shadow: 0 5px 10px 1px rgba(0,0,0,0.1);

	@media ${Format.Smartphone} {
		padding: 10px 25px;
	}
`;

const SearchFieldBar = styled('form')`
	display: flex;
	align-items: center;
	transition: all 0.2s;
	overflow: hidden;
	background: ${StyleColor.Grey50};
	border: 1px solid ${StyleColor.Grey100};
	border-radius: 10px;
	height: 36px;
	width: 100%;
`;

const SearchFieldInput = styled('input')`
	background: ${StyleColor.Grey50};
	flex-grow: 1;
	outline: 0;
	text-overflow: ellipsis;
	color: ${hexToRgba(StyleColor.Black, 50)};
	font-size: 15px;
	letter-spacing: 0.15px;
	border: 0;

	::placeholder{
		color: ${hexToRgba(StyleColor.Black, 50)};
	};

	/* removes the clear field "X" button automatically added by IE & Edge*/
	::-ms-clear {
		display: none;
	}
`;

interface ButtonIconProps {
	isLeft: boolean;
}

const ButtonIcon = styled('button')`
	margin: 0 10px;
	height: 30px;
	width: 30px;
	background: none;
	border: 0;
	outline: 0;
	cursor: pointer;
	z-index: 1;
	padding: 1px 6px;

	svg {
		${(props: ButtonIconProps) => props.isLeft
			? `	fill: ${hexToRgba(StyleColor.Black, 50)};
				height: 16px;
				width: 16px;
			`
			: `	fill: ${StyleColor.Grey500};
				height: 100%;
				width: 100%;
			`
		};
	}
`;

export { SearchFieldContainer, SearchFieldInput, ButtonIcon, SearchFieldBar };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/Search/Field/styles.ts